import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  resultsFromAuthService;
  dxtoken: string = null;
  invalidLogin: boolean;

  constructor(public authService: AuthService, private router: Router) { }

  ngOnInit() {
  }

  loginForm(form: NgForm) {
    const username = form.value.username;
    const password = form.value.password;

    this.invalidLogin = false;

    this.authService.login(username, password)
    .subscribe(results => {
      this.resultsFromAuthService = results;
      // console.log(this.resultsFromAuthService);

      this.dxtoken = this.resultsFromAuthService.response.token;
      // console.log(this.token);

      // if this.token is not empty, set the token to local storage
      if (this.dxtoken) {
        localStorage.setItem('dxtoken', this.dxtoken);
        this.router.navigate(['/']);
      }
    },
    error => {
      this.invalidLogin = true;
      this.resultsFromAuthService = error;
      console.log(this.resultsFromAuthService);
    });
  }

}
